import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { JobNotePreviewProps } from './types';

export const JobNotePreview = ({ data, disabled, onOpen }: JobNotePreviewProps) => {
  const { t } = useTranslation('app');
  const { workflowId } = useParams();

  if (!data?.content) return null;

  return (
    <button
      type="button"
      disabled={disabled || Boolean(workflowId)}
      onClick={(e) => {
        e.stopPropagation();
        onOpen();
      }}
      className="w-full min-w-0 text-left text-xs leading-4 text-neutral-500 enabled:hover:text-neutral-700 xl:hidden max-[899px]:text-sm max-[899px]:leading-5">
      <span className="line-clamp-2 whitespace-pre-line [overflow-wrap:anywhere]">
        <strong className="font-bold">{t('pages.job.info.note.title')}</strong>
        {data.content}
      </span>
    </button>
  );
};
